export const COLORS = {
  SEABLUE: 'seablue',
  NEUTRAL: {
    WHITE: 'white'
  },
  SEMANTIC: {
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger'
  }
};

export const COLORS_SEMANTIC_LIST = Object.values(COLORS.SEMANTIC);
